import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import ResourceSummaryCard
  from 'Components/ComponentLibrary/Components/Uncategorized/ResourceSummaryCard/ResourceSummaryCard';
import { Box, Stack } from '@facet-wealth/design';
import Text from 'Components/ComponentLibrary/Atoms/Text';


export default function ResourceSummaryGroup({
  resourceGroup, onResourceClick, onResourceActionClick, TitleComponent, ItemComponent,
}) {
  let title = <Text weight="medium" variant="h6" color="textPrimary" value={resourceGroup.attr('title')} />;
  if (TitleComponent) {
    title = <TitleComponent title={resourceGroup.attr('title')} />;
  }

  return (
    <>
      <Stack direction={'column'} spacing={2} alignItems="flex-start" justifyContent="flex-start">
        {resourceGroup.attr('title') ? title : null}
        <Box width={'100%'}>
          <Stack direction={'column'} spacing={1}>
            {resourceGroup.attr('items').resources().list().map(resource => (
              <React.Fragment key={resource.id()}>
                <ItemComponent resource={resource} onClick={onResourceClick} onActionClick={onResourceActionClick} />
              </React.Fragment>
            ))}
          </Stack>
        </Box>
      </Stack>
    </>
  );
}
ResourceSummaryGroup.defaultProps = {
  onResourceClick: undefined,
  onResourceActionClick: undefined,
  TitleComponent: undefined,
  ItemComponent: ResourceSummaryCard,
};
ResourceSummaryGroup.propTypes = {
  resourceGroup: PropTypes.instanceOf(fr.Resource).isRequired,
  onResourceClick: PropTypes.func,
  onResourceActionClick: PropTypes.func,
  TitleComponent: PropTypes.func,
  ItemComponent: PropTypes.func,
};


export function ResourceSummaryGroups({
  resourceGroups,
  onResourceClick,
  onResourceActionClick,
  TitleComponent,
  ItemComponent,
}) {
  return (
    <Box width={'100%'}>
      <Stack direction={'column'} spacing={4} alignItems="flex-start" justifyContent="flex-start">
        {resourceGroups.resources().list().map(resourceGroup => (
          <Box width={'100%'} key={resourceGroup.id()}>
            <ResourceSummaryGroup
              resourceGroup={resourceGroup}
              onResourceClick={onResourceClick}
              onResourceActionClick={onResourceActionClick}
              TitleComponent={TitleComponent}
              ItemComponent={ItemComponent}
            />
          </Box>
        ))}
      </Stack>
    </Box>
  );
}

ResourceSummaryGroups.defaultProps = {
  onResourceClick: undefined,
  onResourceActionClick: undefined,
  TitleComponent: undefined,
  ItemComponent: ResourceSummaryCard,
};

ResourceSummaryGroups.propTypes = {
  resourceGroups: PropTypes.instanceOf(fr.Collection).isRequired,
  onResourceClick: PropTypes.func,
  onResourceActionClick: PropTypes.func,
  TitleComponent: PropTypes.func,
  ItemComponent: PropTypes.func,
};
